import React from 'react';

const NotFound = (props) => {
	return <h1>ERROR 404</h1>;
};

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/Common/NotFound.js